import idx from "idx"
import { logTool } from "@jsUtils"

const log = logTool()

/**
 * EXO-243 Business Rules for Page Meta Titles vs content Titles / Names / Category
 * where
 *  pageMeta = pageMeta contentful object
 *  metaData = data/metaData
 * Combine each of the following if present
 * [? pageMeta.pageTitle]
 * [? !pageTitle && Content Title]
 * [? !pageTitle && hard coded title ]
 * [? Category]
 * [? global pageMeta.pageTitle || file metaData.defaultTitle]
 */

/**
 * getImage - get properties from social image
 * @param {object} img - social image from graphql query
 * @returns {object}
 */
function getImage(img) {
  return {
    src: idx(img, _ => _.file.url),
    height: idx(img, _ => _.file.details.image.height),
    width: idx(img, _ => _.file.details.image.width)
  }
}

/**
 * transform - manipulate data for Meta Data from graphql query
 * @param {object} contentfulPageMeta - meta data content from page query
 * @param {object} page - meta data for the page from the page query
 * @param {string} staticTitle - string of text to use in the title
 * @returns {object}
 */
function transform(contentfulPageMeta, page, staticTitle) {
  // site wide (global pageMeta)
  const gPageTitle = idx(contentfulPageMeta, _ => _.pageTitle)
  const gDesc = idx(contentfulPageMeta, _ => _.description)
  const gKeys = idx(contentfulPageMeta, _ => _.keywords)

  const gSocialImage = idx(contentfulPageMeta, _ => getImage(_.socialImage))

  // most page types (page level pageMeta)
  const pTitle = idx(page, _ => _.pageMeta.pageTitle)
  const pDesc = idx(page, _ => _.pageMeta.description)
  const pKeys = idx(page, _ => _.pageMeta.keywords)
  const pSocial = idx(page, _ => getImage(_.pageMeta.socialImage))

  // articles and other content types with title
  const contentTitle = idx(page, _ => _.title)
  const category = idx(page, _ => _.category)

  log("raw meta factory data:", {
    pTitle, // page meta title
    contentTitle, // page title on page object itself
    staticTitle, // passed prop
    category, // category of article etc.
    gPageTitle // global page title
  })

  // collect all the titles
  const titles = [
    pTitle, // include page level pageMeta
    !pTitle && contentTitle,
    !pTitle && staticTitle, // if a string title is present
    category, // if a category exists
    !pTitle && gPageTitle // if no page level meta exists, use global page meta data
  ]
  // toss undefined items
  const finalTitle = titles.filter(item => !!item)

  return {
    title: finalTitle.join(" - "),
    description: pDesc || gDesc,
    keywords: pKeys || gKeys,
    imageObj: pSocial || gSocialImage
  }
}

export default {
  getImage,
  transform
}
